import { render, staticRenderFns } from "./_loading-spinner.vue?vue&type=template&id=b38d2aa0&"
import script from "./_loading-spinner.vue?vue&type=script&lang=js&"
export * from "./_loading-spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports